import * as React from 'react';
import { observer } from 'mobx-react';
import { Page } from '../../components/atoms/layout/Page';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { FaqPane } from '../../components/organisms/faqs/FaqPane';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import './faqPage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';

const REGULAR_MEMBER_FAQ_PATH = 'https://support.she-inc.jp/hc/ja';
@withNavigation(NavigationSpecs.home('white', false))
@observer
export class FaqPage extends React.Component {
    componentDidMount(): void {
        const currentUser = GlobalStatesV3.currentUser;
        if (currentUser.hasEffectiveMembershipToken()) {
            location.href = REGULAR_MEMBER_FAQ_PATH;
        }
    }

    render() {
        return (
            <Page styleName="page">
                <PageHeader title="FAQ" subTitle="よくあるご質問" showOnMobile={true} />
                <PageBody styleName="body">
                    <FaqPane showTrialCta={false} />
                </PageBody>
            </Page>
        );
    }
}
